module.exports = __webpack_public_path__ + "img/about_img07.b6b392f3.png";